// @ts-nocheck

import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import useMergeProps from '../../hooks/useMergeProps';

import MatchTopMyMatch from './MatchTopMyMatch';
import selectMatchTopMyMatchProps from './MatchTopMyMatch.selector';

type MatchTopMyMatchContainerProps = {
  matchId: number;
};
type MatchTopMyMatchProps = MatchTopMyMatchContainerProps & {
  nbTMM: number;
};

const MatchTopMyMatchWithIndex = ({ matchId, nbTMM }: MatchTopMyMatchProps) => {
  const [current, setCurrent] = useState(0);

  const onLoad = useCallback(() => {}, []);

  return <MatchTopMyMatch matchId={matchId} nbTMM={nbTMM} onLoad={onLoad} current={current} setIndex={setCurrent} />;
};

const MatchTopMyMatchContainer = (ownProps: MatchTopMyMatchContainerProps) => {
  const { matchId } = ownProps;
  const history = useHistory();

  const selectorProps = useMemo(() => ({ matchId, history }), [matchId, history]);
  const selectedProps = useSelector((state) => selectMatchTopMyMatchProps(state, selectorProps));
  const pushToHistory = useCallback((route) => history.push(route), [history]);

  const otherProps = useMemo(() => ({ pushToHistory }), [pushToHistory]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <MatchTopMyMatchWithIndex {...enhancedProps} />;
};

export default MatchTopMyMatchContainer;
